import { inject } from '@angular/core';
import { NavigationError } from '@angular/router';

import { UpdateService } from '../services/update.service';

const CHUNK_LOAD_FAILURE = /dynamically imported module|ChunkLoadError|Importing a module script failed|Failed to fetch dynamically/i;

/**
 * Routes a post-deploy chunk failure to the update prompt.
 *
 * A lazy route chunk that 404s means this tab's `index.html` is asking for a hashed
 * filename the new build rotated away — the build already changed, and the user is
 * stuck on a dead navigation. Every other navigation error propagates untouched.
 */
export function handleNavigationError(error: NavigationError): void {
  const message = String((error.error as { message?: string })?.message ?? error.error ?? '');

  if (!CHUNK_LOAD_FAILURE.test(message)) {
    return;
  }

  inject(UpdateService).promptReload('A new version was deployed and this page is out of date. Reload to continue.');
}
